// extracted by mini-css-extract-plugin
module.exports = {"button":"ErrorButton_button__0xuUa"};